import React from "react";
import { useLocation } from "react-router-dom";
import { isRionickSitePage } from "utils/rionick-pages";

const WhatsAppFloat = () => {
  const { pathname } = useLocation();

  if (!isRionickSitePage(pathname)) {
    return null;
  }

  return (
    <a
      className="whatsapp-float"
      href="https://wa.me/918377935429"
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with Rionick Studios on WhatsApp"
    >
      <i className="fa-brands fa-whatsapp" aria-hidden="true"></i>
    </a>
  );
};

export default WhatsAppFloat;
